import React, { useEffect } from "react";
import ProtectedRoute from "./auth/components/ProtectedRoute";
import Layout from "./common/components/Layout";
import Search from "./search/components/Search";
import { Switch } from "react-router-dom";
import { Favorites } from "./common/components/Favorites";
import Profile from "./Profile/components/Profile";
import { CurrentAlarms } from "./alarms/components/CurrentAlarms";
import SafetySensorsView from "./safetySensors/components/SafetySensorsView";
import { DetailedSafetySensor } from "safetySensors/components/DetailedSafetySensor";
import { Details } from "./nodeDetails/components/details/Details";
import { ManageNotifications } from "Profile/components/ManageNotifications";
import { setGlobalTimezone } from "common/DateConverter";
import { IApplicationState } from "redux/root-reducer";
import { useSelector } from "react-redux";
import BillingResult from "nodeDetails/components/billing-result/BillingResult";
import BillingResultList from "nodeDetails/components/billing-result-list/BillingResultList";

const Home: React.FC = () => {
  const timezone = useSelector(
    (state: IApplicationState) =>
      state.common.currentUserInfo.DomainSettings.TimeZone
  );
  useEffect(() => {
    setGlobalTimezone(timezone);
  }, [timezone]);

  return (
    <Layout>
      <Switch>
        <ProtectedRoute exact path="/" Component={<Search />} />

        <ProtectedRoute
          exact
          path="/:domain/:id/details"
          Component={<Details />}
        />
        <ProtectedRoute
          exact
          path="/:domain/:id/billing-results/:billingResultId"
          Component={<BillingResult />}
        />
        <ProtectedRoute
          exact
          path="/:domain/:id/billing-results"
          Component={<BillingResultList />}
        />
        <ProtectedRoute
          exact
          path="/:domain/favorites"
          Component={<Favorites />}
        />
        <ProtectedRoute exact path="/favorites" Component={<Favorites />} />
        <ProtectedRoute exact path="/:domain/profile" Component={<Profile />} />
        <ProtectedRoute
          exact
          path="/:domain/profile/changepassword"
          Component={<Profile changePasswordOpenInitial={true} />}
        />
        <ProtectedRoute
          exact
          path="/:domain/profile/manage-notifications"
          Component={<ManageNotifications />}
        />
        <ProtectedRoute exact path="/profile" Component={<Profile />} />

        <ProtectedRoute
          exact
          path="/:domain/safetySensorDetails/:id/:currentSensorDetail"
          Component={<DetailedSafetySensor />}
        />
        <ProtectedRoute
          exact
          path="/safetySensorDetails/:id/:currentSensorDetail"
          Component={<DetailedSafetySensor />}
        />

        <ProtectedRoute
          exact
          path="/:domain/:safetySensors/:id"
          Component={<SafetySensorsView />}
        />
        <ProtectedRoute
          exact
          path="/safetySensors/:id"
          Component={<SafetySensorsView />}
        />
        <ProtectedRoute
          exact
          path="/currentAlarms"
          Component={<CurrentAlarms />}
        />
      </Switch>
    </Layout>
  );
};

export default Home;
